import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementSelect'], (item) => {
  return {
    $formkit: 'select',
    options: item.element.options,
  }
})
